module.exports = {
	"_args": [
		[
			{
				"raw": "azure-iot-device@1.1.7",
				"scope": null,
				"escapedName": "azure-iot-device",
				"name": "azure-iot-device",
				"rawSpec": "1.1.7",
				"spec": "1.1.7",
				"type": "version"
			},
			"C:\\projects\\iot-devkit-web-simulator"
		]
	],
	"_from": "azure-iot-device@1.1.7",
	"_id": "azure-iot-device@1.1.7",
	"_inCache": true,
	"_location": "/azure-iot-device",
	"_nodeVersion": "6.9.5",
	"_npmOperationalInternal": {
		"host": "packages-18-east.internal.npmjs.com",
		"tmp": "tmp/azure-iot-device-1.1.7.tgz_1488221056434_0.8069348027929664"
	},
	"_npmUser": {
		"name": "windowsazure",
		"email": "azuresdk@outlook.com"
	},
	"_npmVersion": "3.10.10",
	"_phantomChildren": {
		"crypto": "0.0.3"
	},
	"_requested": {
		"raw": "azure-iot-device@1.1.7",
		"scope": null,
		"escapedName": "azure-iot-device",
		"name": "azure-iot-device",
		"rawSpec": "1.1.7",
		"spec": "1.1.7",
		"type": "version"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/azure-iot-device/-/azure-iot-device-1.1.7.tgz",
	"_shasum": "faad0095b7c6e758cbfd4d42aae1db35dabf72ea",
	"_shrinkwrap": null,
	"_spec": "azure-iot-device@1.1.7",
	"_where": "C:\\projects\\iot-devkit-web-simulator",
	"author": {
		"name": "Microsoft Corporation"
	},
	"bugs": {
		"url": "https://github.com/Azure/azure-iot-sdk-node/issues"
	},
	"dependencies": {
		"azure-iot-common": "1.1.5",
		"azure-iot-http-base": "1.1.5",
		"azure-storage": "^2.0.0",
		"debug": "^2.6.0",
		"es5-shim": "^4.5.9",
		"lodash": "^4.17.4",
		"machina": "^2.0.0",
		"traverse": "^0.6.6"
	},
	"description": "Azure IoT device SDK",
	"devDependencies": {
		"chai": "^3.5.0",
		"istanbul": "^0.4.5",
		"jshint": "^2.9.4",
		"mocha": "^3.2.0",
		"sinon": "^1.17.7",
		"tslint": "^3.14.0",
		"typescript": "^1.8.10"
	},
	"directories": {},
	"dist": {
		"shasum": "faad0095b7c6e758cbfd4d42aae1db35dabf72ea",
		"tarball": "https://registry.npmjs.org/azure-iot-device/-/azure-iot-device-1.1.7.tgz"
	},
	"engines": {
		"node": ">= 0.10"
	},
	"homepage": "https://github.com/Azure/azure-iot-sdk-node#readme",
	"license": "MIT",
	"main": "device.js",
	"maintainers": [
		{
			"name": "windowsazure",
			"email": "azuresdk@outlook.com"
		}
	],
	"name": "azure-iot-device",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/Azure/azure-iot-sdk-node.git"
	},
	"scripts": {
		"alltest": "istanbul cover node_modules/mocha/bin/_mocha -- --reporter spec \"test/**/_*_test*.js\"",
		"alltest-min": "istanbul cover --report none node_modules/mocha/bin/_mocha -- --reporter dot \"test/**/_*_test*.js\"",
		"check-cover": "istanbul check-coverage --statements 98 --branches 94 --functions 98 --lines 98",
		"ci": "npm -s run lint && npm -s run alltest-min && npm -s run check-cover",
		"lint": "jshint --show-non-errors . && tslint -c ../../tslint.json \"{lib,.}/*.ts\"",
		"test": "npm -s run lint && npm -s run unittest",
		"unittest": "istanbul cover node_modules/mocha/bin/_mocha -- --reporter spec \"test/**/_*_test.js\"",
		"unittest-min": "istanbul cover --report none node_modules/mocha/bin/_mocha -- --reporter dot \"test/**/_*_test.js\""
	},
	"typings": "device.d.ts",
	"version": "1.1.7"
};


//////////////////
// WEBPACK FOOTER
// ./~/azure-iot-device/package.json
// module id = 371
// module chunks = 0